module.exports = __webpack_public_path__ + "static/media/mobile-app-mockup.1c571345.png";